import { createFileRoute } from "@tanstack/react-router";

import { Dashboard } from "#app/widgets/dashboards/dashboard";
import { WidgetsGate } from "#app/widgets/dashboards/widgets-gate";
import { TEAM_OVERVIEW_WIDGETS } from "#app/widgets/dashboards/team-overview-widgets";

/**
 * `/team/$teamId/overview` — the managed widget board (Members, Active
 * projects, Workload, Recent activity) on its own persisted `-overview`
 * variant. The tab only exists under WIDGETS; with the flag off a deep link
 * redirects to the board (the flag-off landing view). Flags resolve async, so
 * hold on a spinner until `ready` — deciding early would bounce flag-on users
 * to the board on a fresh load.
 */
function TeamOverviewRoute() {
  const { workspace, teamId } = Route.useParams();
  if (!teamId) return null;
  return (
    <WidgetsGate redirectTo={`/${workspace}/team/${teamId}/board`}>
      <Dashboard
        scope={{ kind: "team", teamId }}
        managedCatalog={TEAM_OVERVIEW_WIDGETS}
        surfaceVariant="overview"
      />
    </WidgetsGate>
  );
}

export const Route = createFileRoute("/(app)/$workspace/team/$teamId/overview")({
  component: TeamOverviewRoute,
});
